var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":_vm.fit20.storageBaseUrl + '/static/images/fit20-spiner-logo.png'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }